import React, { useState, useEffect } from 'react'
import Copy from '../../cpn/Copy';
import classes from './invoice.module.css';
import { Table } from 'antd';
import InvoiceCheck from './InvoiceCheck';
import StateTag from '../../cpn/StateTag';
import ReportCheck from '../../document/report/ReportCheck';
function InvoiceListNeedApprove(props) {
    const [list, setList] = useState([]);
    useEffect(() => {
        if (props.invoiceSpList) {
            const arr = props.invoiceSpList.filter((item) => item.kpsq_sp_state === '2' && item.kpsq_sp_jd_name === '审批');
            setList(arr);
        }
    }, [props.invoiceSpList]);

    const columns = [
        {
            title: '开票客户  ',
            dataIndex: 'kpsq_kh_name',
            key: 'kpsq_kh_name',
            width: "20%",
            render: (_, record) =>  <InvoiceCheck
                                        type='button'
                                        kpsq_id={record.kpsq_sp_kpsq_id} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        kpsq_bzd_id={record.kpsq_bzd_id}
                                        kpsq_price={record.kpsq_price}
                                        kpsq_content={record.kpsq_content}
                                        kpsq_date={record.kpsq_date}
                                        kpsq_date_end={record.kpsq_date_end}
                                        kpsq_bzd_name={record.kpsq_bzd_name}
                                        kpsq_bzd_danhao={record.kpsq_bzd_danhao}
                                        kpsq_type_id={record.kpsq_type_id}
                                        kpsq_type_name={record.kpsq_type_name}
                                        kpsq_kh_id={record.kpsq_kh_id}
                                        kpsq_kh_name={record.kpsq_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        kpsq_num={record.kpsq_num}
                                        kpsq_amount={record.kpsq_amount}
                                        kpsq_state={record.kpsq_state}
                                        kpsq_bm_id={record.kpsq_bm_id}
                                        kpsq_bm_name={record.kpsq_bm_name}
                                        kpsq_khyhzh_id={record.kpsq_khyhzh_id}
                                        kpsq_khyhzh_name={record.kpsq_khyhzh_name}
                                        kpsq_image_name={record.kpsq_image_name}
                                        kpsq_image_file={record.kpsq_image_file}
                                        kpsq_ctime={record.kpsq_ctime}
                                        kpsq_sp_state={record.kpsq_sp_state}
                                        kpsq_sp_state_time={record.kpsq_sp_state_time}
                                        kpsq_sp_kpsq_kh_name={record.kpsq_sp_kpsq_kh_name}
                                    />
        },
        {
            key: 'kpsq_sp_kpsq_amount',
            dataIndex: 'kpsq_sp_kpsq_amount',
            title: "开票金额",
            width: "6%",            
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
      
        {
            key: 'kpsq_sp_kpsq_name',
            dataIndex: 'kpsq_sp_kpsq_name',
            title: "开票项目",
            width: "8%",
            render: (text, record) => <Copy title={record.kpsq_sp_kpsq_name}/>
        },
        {
            key: 'kpsq_sp_dsbzd_name',
            dataIndex: 'kpsq_sp_dsbzd_name',
            title: "团队名称",
            width: "8%",
            render: (text, record) => <ReportCheck dsbzd_name={record.kpsq_sp_dsbzd_name} dsbzd_id={record.kpsq_sp_dsbzd_id} dsbzd_danhao={record.kpsq_sp_dsbzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
        },
        
        {
            title: '状态',
            dataIndex: 'kpsq_sp_state',
            width: '5%',
            key: 'kpsq_sp_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'kpsq_sp_kpsq_id',
            width: '5%',
            key: 'kpsq_sp_kpsq_id',                        
        },       
    ]
    return (
        <>
            <Table 
                className={classes.orangeHeader}
                size='small'
                bordered
                dataSource={list} 
                columns={columns} 
                rowKey='kpsq_sp_id'
                locale={{
                    emptyText: '暂无开票申请' // This will display text when the table is empty
                }}
            />

        </>
    )
}

export default InvoiceListNeedApprove